import { depositPfService, depositStarshopService } from "@/common/api.service"
import { depositStatus } from "@/constants/deposit"

const initialStates = {
    status: 'loading',
    status_starshop: 'loading',
    general_setting_status: 'loading',
    accounts_status: 'loading',
    verified_companies_status: 'loading',
    deposits: [],
    deposits_starshop: [],
    form_data: {
        access_ips:[]
    },
    general_setting :{},
    accounts :{},
    verified_companies :{}
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingStarshop(state) {
        state.status_starshop = 'loading'
    },
    generalSettingLoading(state) {
        state.general_setting_status = 'loading'
    },
    accountsLoading(state) {
        state.accounts_status = 'loading'
    },
    success(state, deposits) {
        state.status  = 'success'
        state.deposits = deposits
    },
    successStarshop(state, deposits) {
        state.status_starshop  = 'success'
        state.deposits_starshop = deposits
    },
    fail(state) {
        state.status  = 'fail'
        state.deposits = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key) {
            state.form_data[key] = ''
        });
    },
    setGeneralSetting(state, general_setting) {
        state.general_setting_status = 'success'
        state.general_setting = general_setting
    },
    setAccounts(state, accounts) {
        state.accounts_status = 'success'
        state.accounts = accounts
    },
    setVerifiedCompanies(state, verified_companies) {
        state.verified_companies_status = 'success'
        state.verified_companies = verified_companies
    }
}

const getters = {
    status: ({status}) => status,
    status_starshop: ({status_starshop}) => status_starshop,
    general_setting_status: ({general_setting_status}) => general_setting_status,
    deposits: ({deposits}) => deposits,
    deposits_starshop: ({deposits_starshop}) => deposits_starshop,
    accounts: ({accounts}) => accounts,
    accounts_status: ({accounts_status}) => accounts_status,
    form_data: ({form_data}) => form_data,
    general_setting: ({general_setting}) => general_setting,
    verified_companies: ({verified_companies}) => verified_companies,
    verified_companies_status: ({verified_companies_status}) => verified_companies_status,
    active_deposits: ({deposits}) => {
        if(deposits.data) {
            return deposits.data.filter(deposit =>
                deposit.status === depositStatus.ACTIVE
            )
        }
        return deposits.filter(deposit =>
            deposit.status === depositStatus.ACTIVE
        )
    }
}

const actions = {
    // fetch({commit}) {
    //     commit('loading')
    //     return depositService.fetch().then(response => {
    //         commit('success', response.data.data)
    //     })
    // },
    // fetchByUserId({commit}, user_id) {
    //     commit('loading')
    //     let params = {
    //         'user_id': user_id
    //     }
    //     return depositService.find(user_id).then(response => {
    //         commit('success', response.data.data)
    //     })
    // },
    fetchByUserIdPfAdmin({commit}, user_id) {
        commit('loading')
        let query = `query[user_id]=${user_id}`
        return depositPfService.getForAdmin(query).then(response => {
            commit('success', response.data.data.data)
        })
    },
    fetchByUserIdStarshopAdmin({commit}, user_id) {
        commit('loadingStarshop')

        let query = `query[user_id]=${user_id}`
        return depositStarshopService.getForAdmin(query).then(response => {
            commit('successStarshop', response.data.data.data)
        })
    },
    // fetchUserGateways({commit}, user_id) {
    //     commit('loading')
    //     let params = {
    //         'user_id': user_id,
    //         'perpage': 1000,
    //     }
    //     return depositService.fetch(params).then(response => {
    //         commit('success', response.data.data.data)
    //     })
    // },
    // find({commit}, hashid) {
    //     commit('loading')
    //
    //     return depositService.find(hashid).then(response => {
    //         commit('setFormData', response.data.data)
    //     })
    // },
    adminFind({commit}, {hashid, is_starshop = false}) {
        commit('loading')
        let service = is_starshop ? depositStarshopService : depositPfService;
        return service.adminFind(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    },
    getGeneralSetting({commit}, is_starshop = false) {
        commit('generalSettingLoading')
        let service = is_starshop ? depositStarshopService : depositPfService;
        return service.getGeneralSetting().then(response => {
            commit('setGeneralSetting', response.data.data)
        })
    },
    getAccounts({commit}, is_starshop = false) {
        commit('accountsLoading')
        let service = is_starshop ? depositStarshopService : depositPfService;
        return service.accountsGetAccounts().then(response => {
            commit('setAccounts', response.data.data.data)
        })
    },
    updateGeneralSetting({commit}, params) {
        commit('setGeneralSetting', params)
    },
    fetchVerifiedCompanies({commit}, is_starshop = false) {
        let service = is_starshop ? depositStarshopService : depositPfService;
        return service.getVerifiedCompanies().then(response => {
            commit('setVerifiedCompanies', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}